import styled from 'styled-components';
import { DropdownHeading } from '../DropdownHeading/DropdownHeading';

/**
 * The `Menu` component is usually limited to a list of `MenuItem` actions, but you can add
 * a heading with this component.
 *
 * @extends DropdownHeading
 * @since 8.61.0
 */
var MenuHeading = /*#__PURE__*/styled(DropdownHeading).withConfig({
  displayName: "MenuHeading",
  componentId: "c11n-8-99-3__sc-prckc5-0"
})([""]);
MenuHeading.displayName = 'MenuHeading';

/** @component */
export { MenuHeading };